<template>
    <div class="traceability-contract-main-page">
        <base-header
            class="traceability-contract-main-page__header"
            :titulo="translate('messages.main_title')"
            icon="el-icon-plus"
            :exibe-botao="isRegistrant"
            :btn-texto="translate('messages.create_title')"
            @btnHeaderClicado="add()"
        />
        <div class="view-container-wrapper">
            <div class="content">
                <filters />
                <summary-component />
                <contract-list />
            </div>
        </div>
    </div>
</template>

<script>
import BaseHeader from '@/components/BaseHeader.vue';
import ContractList from '@/modules/traceability-contract/views/pages/main/components/contract-list/index.vue';
import Filters from '@/modules/traceability-contract/views/pages/main/components/shared/filters/index.vue';
import SummaryComponent from '@/modules/traceability-contract/views/pages/main/components/shared/summary/index.vue';
import { mapGetters } from 'vuex';

export default {
    name: 'MainRegistrantPage',
    components: { BaseHeader, ContractList, Filters, SummaryComponent },
    computed: {
        ...mapGetters('traceabilityContractModule', ['isRegistrant'])
    },
    methods: {
        translate(key, params = {}) {
            const base = 'contrato_rastreabilidade';
            return this.$t(`${base}.${key}`, params);
        },
        add() {
            this.$router.push({ name: 'contrato-rastreabilidade-cadastro' });
        }
    }
};
</script>

<style scoped lang="scss">
.traceability-contract-main-page {
    .view-container-wrapper {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    .content {
        display: flex;
        flex-direction: column;
        gap: 16px;
        padding: 16px;
    }
}
</style>
